import React, { useContext } from 'react';
import { RouteProps } from 'react-router-dom';

import NvRouter from 'shared/components/nv-router';
import { AngularContext } from 'react-app';

import NewConversationView from './new-conversation-view';
import SubmissionFeedbackView from './submission-feedback-view';
import SubmissionsGallery from './submissions-gallery';

const routes: RouteProps[] = [
  { path: '/new', component: NewConversationView, exact: true },
  { path: '/:submissionId', component: SubmissionFeedbackView, exact: true },
  { path: '/', component: SubmissionsGallery, exact: true },
];

const RolePlaySubmission = () => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const rolePlayId = $state?.params?.rolePlayId;
  if (!Number.isFinite(Number(rolePlayId))) {
    return null;
  }

  return (
    <NvRouter
      basename={`/#!/role-play/${rolePlayId}/submission`}
      routes={routes}
    />
  );
};

export default RolePlaySubmission;
